// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2VUtE","content":"GlobalSearch_content__2E-ib"};